import { create } from "zustand";
import { persist } from "zustand/middleware";

const ONE_DAY_MS = 86400 * 1000;

interface PopupBannerState {
  dismissedUntil: number;
  dismiss: () => void;
}

/**
 * 오늘 「다시 보지 않기」로 닫힌 상태인지.
 *
 * 시각 비교를 컴포넌트 렌더 밖으로 뺀다 — 렌더 중 `Date.now()` 직접 호출은 순수성 규칙
 * 위반이다(`react-hooks/purity`). `welcome-coupon-popup-store` 의 동명 헬퍼와 같은
 * 형태이고, 그쪽 주석이 근거다.
 *
 * ⚠️ 종전엔 `floating-popup` 이 렌더 중에 직접 비교했다. 그 컴포넌트가 **한 번도
 * 렌더되지 않아** 린트 오류가 아무 영향을 주지 않았을 뿐이다.
 */
export const isDismissedToday = (
  dismissedUntil: number,
  now: number = Date.now(),
): boolean => dismissedUntil > now;

export const usePopupBannerStore = create<PopupBannerState>()(
  persist(
    (set) => ({
      dismissedUntil: 0,
      dismiss: () => {
        set({ dismissedUntil: Date.now() + ONE_DAY_MS });
      },
    }),
    {
      name: "popup-banner",
      partialize: (state) => ({ dismissedUntil: state.dismissedUntil }),
    },
  ),
);
